// extracted by mini-css-extract-plugin
module.exports = {"label":"styles_label__2WrzL","indicator":"styles_indicator__2_SPo","checked":"styles_checked__1hRRJ"};